// components
import { 
    FaFacebookF,
    FaInstagram,
    FaLinkedinIn,
    FaYoutube,
    FaXTwitter
} from "react-icons/fa6";
// types
import TLanguageVersionDetail from "@/cms/types/TLanguageVersionDetail";
// utilities
import LanguageVersionSelector from "@/utilities/LanguageVersionSelector";
// enums
import EView from "@/cms/enums/EView";
import EViewType from "@/cms/enums/EViewType";
// type
import { 
    TSocialMediaItem,
    TSocialMedia
} from "../type";


const SocialMedias = {
    "facebook":  { logo: FaFacebookF,   title: "Facebook" },
    "instagram": { logo: FaInstagram,   title: "Instagram" },
    "youtube":   { logo: FaYoutube,     title: "Youtube" },
    "linkedin":  { logo: FaLinkedinIn,  title: "LinkedIn" },
    "twitter_x": { logo: FaXTwitter,    title: "X" },
}

const SocialMediaItem = ( props:TSocialMediaItem ) => {
    
    const itemLanguageVersion = LanguageVersionSelector<TLanguageVersionDetail|null>({
        languageVersions: props.payload,
        filters:[{
            view: EView.META_DATA, viewType: EViewType.TEXT, name: props.type
        }],
        type: "find"
    });
    const item = SocialMedias[props.type];

    if ( itemLanguageVersion && item ) 
        return <a className={props.itemClassName} title={item.title} data-tooltip={item.title} aria-label={item.title} href={itemLanguageVersion.value||""}><item.logo className={props.logoClassName} /></a>

}

const SocialMedia01 = ( props:TSocialMedia ) => {

    if ( !props.payload ) return null;

    return (
        <div className={props.className}>
            <SocialMediaItem type="facebook" payload={props.payload} className={props.liClassName} itemClassName={props.aClassName} logoClassName={props.logoClassName} />
            <SocialMediaItem type="twitter_x" payload={props.payload} className={props.liClassName} itemClassName={props.aClassName} logoClassName={props.logoClassName} />
            <SocialMediaItem type="instagram" payload={props.payload} className={props.liClassName} itemClassName={props.aClassName} logoClassName={props.logoClassName} />
            <SocialMediaItem type="linkedin" payload={props.payload} className={props.liClassName} itemClassName={props.aClassName} logoClassName={props.logoClassName} />
            <SocialMediaItem type="youtube" payload={props.payload} className={props.liClassName} itemClassName={props.aClassName} logoClassName={props.logoClassName} />
        </div>        
    );
    
}

export default SocialMedia01;
